const getInitialDates = (diff) => {
    let today = getDateWithoutTime(new Date());
    let prev = getDateWithoutTime(new Date());
    let currentMonth = today.getMonth();
    let prevMonth = currentMonth - diff;
    prev.setMonth(prevMonth);
    today.setDate(today.getDate() + 1);
    return {
        start: prev,
        end: today,
    };
};

const getDateFromSeconds = (seconds) => {
    return new Date(seconds * 1000);
};

const getDatePlusMonths = (months) => {
    let today = getDateWithoutTime(new Date());
    let future = getDateWithoutTime(new Date());
    let currentMonth = today.getMonth();
    let futureMonth = currentMonth + months;
    future.setMonth(futureMonth);
    return {
        start: shortDateYMD(today),
        end: shortDateYMD(future),
    };
};

const getDateWithoutTime = (dateTime) => {
    if (dateTime) {
        var date = new Date(dateTime.getTime());
        date.setHours(0, 0, 0, 0);
        return date;
    }
};

const getCurrentDateYMD = () => {
    const currentDate = shortDateYMD(new Date());
    return currentDate;
};

//shortDateYMD => 2020-01-30
const shortDateYMD = (date, addDays = 0) => {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + addDays);
    let stringDate = [
        newDate.getFullYear(),
        ("0" + (newDate.getMonth() + 1)).slice(-2),
        ("0" + newDate.getDate()).slice(-2),
    ].join("-");
    return stringDate;
};

const getDateTimeWithTimeZone = (date) => {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000 * -1);
};

const checkDateFormat = (date) => {
    let d = new Date(date);
    if (date && typeof date === "string" && !date.includes("T"))
        d = getDateTimeWithTimeZone(d);
    return d;
};

//longDateTime => January 1, 2022, 02:00 AM
const longDateTime = (date) => {
    try {
        const DateOptions = {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        };
        const d = checkDateFormat(date);

        return d.toLocaleDateString("en-US", DateOptions);
    } catch (error) {
        return new Date().toLocaleDateString("en-US", DateOptions);
    }
};

const shortDateTime = (date) => {
    try {
        const DateOptions = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        };
        const d = checkDateFormat(date);

        return d.toLocaleDateString("en-US", DateOptions);
    } catch (error) {
        return new Date().toLocaleDateString("en-US", DateOptions);
    }
};

//longDate => August 1, 2021
const longDate = (date) => {
    try {
        const DateOptions = {
            year: "numeric",
            month: "long",
            day: "numeric",
        };
        const d = checkDateFormat(date);

        return d.toLocaleDateString("en-US", DateOptions);
    } catch (error) {
        return new Date().toLocaleDateString("en-US", DateOptions);
    }
};

const getDateRange = (startDate, endDate, difference) => {
    let max = "";
    let min = "";

    if (startDate) {
        max = new Date(startDate);
        max = shortDateYMD(calculateDateMonth(max, difference, true));
    }

    if (endDate) {
        min = new Date(endDate);
        min = shortDateYMD(calculateDateMonth(min, difference, false));
    }

    return { min, max };
};

const calculateDateMonth = (date, difference, isAddition) => {
    let currentDate = new Date();
    let newDate = new Date(date);
    isAddition
        ? newDate.setMonth(newDate.getMonth() + difference)
        : newDate.setMonth(newDate.getMonth() - difference);
    if (newDate > currentDate) return currentDate;
    else return newDate;
};

const addDateToDate = (
    date = new Date(),
    dayChange = 0,
    monthChange = 0,
    yearChange = 0
) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(year + yearChange, month + monthChange, day + dayChange);
};

const getTimezoneoffset = () => {
    return new Date().getTimezoneOffset() / -60;
};

const getNumberOfDaysBetweenDates = (
    date1 = new Date(),
    date2 = new Date()
) => {
    const diffInTime = date1.getTime() - date2.getTime();
    return Math.abs(diffInTime / (1000 * 3600 * 24));
};

export {
    getInitialDates,
    getDateWithoutTime,
    longDateTime,
    shortDateYMD,
    longDate,
    shortDateTime,
    getDateRange,
    calculateDateMonth,
    getDateFromSeconds,
    getCurrentDateYMD,
    getDatePlusMonths,
    addDateToDate,
    getTimezoneoffset,
    getNumberOfDaysBetweenDates,
};
